import { Box, Grid, Typography, Button } from 'src/components';
import { useIsMobile } from 'src/hooks';

import MerchImage from 'src/assets/merch-banner.png'; 
import MerchMobileImage from 'src/assets/merch-banner-mobile.png'; 

const MerchSection = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ bgcolor: '#f2f5f7' }}>
        <Grid container spacing={4} alignItems="center" columns={2}>

          {/*<Grid size={1} sx={{paddingLeft: '60px'}}>
            <Typography variant="h2" fontWeight={600} gutterBottom>
              Merch Coming Soon!
            </Typography>
            <Typography variant="h5" sx={{ mb: 3 }}>
              Tshirts, stickers and more - for the world's greatest road trip.
            </Typography>
            <Button variant="contained" color="secondary" size="large" sx={{borderRadius: 100}}>
              Coming Soon
            </Button>
          </Grid>*/}

          <Grid size={2}>
            <Box
              component="img"
              src={isMobile ? MerchMobileImage : MerchImage}
              alt="Adventure awaits"
              sx={{
                width: '100%',
                boxShadow: 0, 
                maxHeight: isMobile ? '' : '400px'
              }}
            />
          </Grid>

        </Grid>
    </Box>
  );
};

export default MerchSection;
